import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { configureApi } from '@expat-ui/shared';
import { App } from './app/App';
import './styles/scss/main.scss';

configureApi(import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000');

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
